import NOT_FOUND from '@/views/error/404'
import NOT_SUPPORT from '@/views/error/notsupport'
import HORIZONTAL_TIP from '@/views/error/horizontal-tip'

export default [
  {
    path: '/notsupport',
    name: 'notsupport',
    component: NOT_SUPPORT,
    meta: {
      noauth: true,
      bindloadevent: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: NOT_FOUND,
    meta: {
      noauth: true
    }
  },
  {
    path: '/horizontaltip',
    name: 'horizontal-tip',
    component: HORIZONTAL_TIP,
    meta: {
      noauth: true
    }
  }
]
